/**
 *
 * Some of these types have been copied into TOSA in /src/analytics/utils/getGeolocationData.ts in order to faciliate using this data in that application.
 *
 * Any changes to that contract must be duplicated in that file while the two apps are coupled together
 *
 */

import type { Request } from 'express';

type GeolocationProperties =
  | 'dma'
  | 'city'
  | 'state'
  | 'zip'
  | 'country'
  | 'ip';

type GeolocationHeaderMap = {
  [k in GeolocationProperties]: string;
};

export const geoLocationHeaderMap: GeolocationHeaderMap = {
  dma: 'cf-metro-code',
  city: 'cf-ipcity',
  state: 'cf-region-code',
  zip: 'cf-postal-code',
  country: 'cf-ipcountry',
  ip: 'cf-connecting-ip',
};

export type GeolocationData = {
  [k in GeolocationProperties]?: string;
};

export const geolocationWindowProperty = '__geolocationData';

export function getGeolocationDataFromHeaders(req: Request): GeolocationData {
  const geoKeysToHeadersList = Object.entries(geoLocationHeaderMap);
  return geoKeysToHeadersList.reduce((geoValues, [key, header]) => {
    const value = req.get(header);
    return value ? { ...geoValues, [key]: value } : geoValues;
  }, {});
}
